import React, { useState, useEffect } from 'react'
import { Modal, Table, Tag, message } from 'antd'
import moment from 'moment'
import axios from '../../util/Api'

const STATUS_COLORS = {
  PLANNED: 'blue', STARTED: 'green', COMPLETED: 'geekblue'
}
const prettify = (v) => (v ? v.charAt(0) + v.slice(1).toLowerCase() : '-')
const fmt = (d) => d ? moment(d).format('DD/MM/YYYY HH:mm') : '-'

// mode: 'start' -> lists PLANNED/STARTED trips; 'end' -> lists STARTED/COMPLETED trips.
function TripSelectModal ({ visible, mode, assetId, onSelect, onCancel }) {
  const [loading, setLoading] = useState(false)
  const [trips, setTrips] = useState([])

  useEffect(() => {
    if (visible && assetId) {
      const statuses = mode === 'end' ? 'STARTED,COMPLETED' : 'PLANNED,STARTED'
      setLoading(true)
      axios.get(`/fleet-trip/selectable?asset=${assetId}&statuses=${statuses}`)
        .then(res => setTrips(res.data || []))
        .catch(() => { message.error('Failed to load trips'); setTrips([]) })
        .finally(() => setLoading(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, assetId, mode])

  const columns = [
    { title: 'Trip No', dataIndex: 'tripNo' },
    { title: 'Name', dataIndex: 'tripName' },
    { title: 'Type', dataIndex: 'tripType', render: prettify },
    { title: 'Status', dataIndex: 'tripStatus', render: (s) => <Tag color={STATUS_COLORS[s] || 'default'}>{prettify(s)}</Tag> },
    {
      title: mode === 'end' ? 'Actual/Proposed End' : 'Actual/Proposed Start',
      render: (r) => mode === 'end'
        ? fmt(r.actualEndDateTime || r.proposedEndDateTime)
        : fmt(r.actualStartDateTime || r.proposedStartDateTime)
    }
  ]

  return (
    <Modal
      title={mode === 'end' ? 'Select Trip to End' : 'Select Trip to Start'}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={760}
      destroyOnClose
    >
      <Table
        rowKey={(r) => r._id}
        loading={loading}
        columns={columns}
        dataSource={trips}
        size='small'
        pagination={{ pageSize: 8 }}
        onRow={(record) => ({ onClick: () => onSelect(record), style: { cursor: 'pointer' } })}
        locale={{ emptyText: assetId ? 'No eligible trips for this asset' : 'Select an asset first' }}
      />
      <div style={{ marginTop: 8, color: '#8c8c8c', fontSize: 12 }}>Click a row to select the trip.</div>
    </Modal>
  )
}

export default TripSelectModal
